export default class StaticArticle {
  constructor(section) {
    this.initializedClass = 'article-initialized';
    this.el = section.el;
    this._validate();
  }

  update() {
    this._validate();
  }

  onSectionUnload() {
    window.removeEventListener('resize', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });
  }

  _validate() {
    if (window.innerWidth <= 1080) {
      this.positionSidebar('below');
    } else {
      this.positionSidebar();
    }

    this.setupFeaturedImage();
    this.setupFullWidthImages();

    window.addEventListener('resize', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });
  }

  setupFeaturedImage() {
    const posts = this.el.querySelectorAll('.blog-post');

    posts.forEach(post => {
      const image = post.querySelector('img.highlight');

      if (image) {
        image.addEventListener('rimg:load', () => {
          post.querySelector('.blog-post-inner').style.paddingTop = `${image.getBoundingClientRect().height - 60}px`;
        });
      }
    });
  }

  setupFullWidthImages() {
    const postContent = this.el.querySelector('.post-content');
    const postContentWidth = postContent.getBoundingClientRect().width;
    const postContentMargin = postContent.style.marginLeft;

    this.el.querySelectorAll('img.full-width').forEach(image => {
      image.style.width = `${postContentWidth}px`;
      image.style.left = `-${postContentMargin}px`;
    });
  }

  positionSidebar(position) {
    const wrapper = this.el.querySelector('.blog-post-wrapper');
    const sidebar = this.el.querySelector('.blog-sidebar');

    if (position === 'below') {
      wrapper.parentNode.insertBefore(sidebar, wrapper.nextSibling);
    } else {
      wrapper.parentNode.insertBefore(sidebar, wrapper);
    }
  }
}
